import { Button } from '@energybox/react-ui-library/dist/components';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { clearSentinelsStore, getSentinels } from '../../actions/sentinels';
import IndexManagementPageLayout from '../../components/IndexManagementPageLayout';
import history from '../../history';
import { ApplicationState } from '../../reducers';
import { Routes } from '../../routes';
import SentinelsTable, { SentinelTableColumns } from './SentinelsTable';
import TabLink from '../../components/TabLink';
import RemindersTable, { ReminderTableColumns } from './RemindersTable';
import { getReminders } from '../../actions/reminder';
import { useLocation } from 'react-router-dom';
import AlertNotification from './AlertNotification';

interface Props {}

const sentinelTableColumns = [
  SentinelTableColumns.CONFIG,
  SentinelTableColumns.RECIPIENTS,
  SentinelTableColumns.TARGETS,
  SentinelTableColumns.MUTED_TARGETS,
  // SentinelTableColumns.CHANNEL_TYPE,
  SentinelTableColumns.RESUME_CONFIG,
  SentinelTableColumns.MUTE,
  // Declare the new column name for duplicate a sentinel select box
  SentinelTableColumns.DUBLICATE_SENTINEL,
];

const reminderTableColumns = [
  ReminderTableColumns.CONFIG,
  ReminderTableColumns.RECIPIENTS,
  ReminderTableColumns.SITES,
  ReminderTableColumns.EQUIPMENTS,
  ReminderTableColumns.RESUME_CONFIG,
  ReminderTableColumns.ACTIONS,
];

function SentinelsIndexPage(props: Props) {
  const dispatch = useDispatch();
  const path = history.location.pathname;
  const [shouldRefetchSentinels, setShouldRefetchSentinels] = useState(true);

  const location = useLocation();
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [alertType, setAlertType] = useState<'success' | 'error' | null>(null);

  const sentinels = useSelector(({ sentinels }: ApplicationState) =>
    Object.values(sentinels.byId)
  );
  const getSentinelsIsLoading = useSelector(
    ({ sentinels }: ApplicationState) => sentinels.isLoading
  );
  const pendingMuteTargetsUpdate = useSelector(
    ({ sentinels }: ApplicationState) => sentinels.pendingMuteTargetsUpdates
  );
  const {
    reminders,
    isLoading: isReminderLoading,
    isInitialized,
  } = useSelector(({ reminder }: ApplicationState) => reminder);

  useEffect(() => {
    const state = location.state as any;
    if (state && state.successAlert) {
      setAlertMessage(state.successAlert);
      setAlertType('success');
      setTimeout(() => {
        setAlertMessage(null);
        setAlertType(null);
        history.replace({ ...history.location, state: {} });
      }, 2500);
    }
  }, [location]);

  useEffect(() => {
    if (pendingMuteTargetsUpdate === 0) {
      setShouldRefetchSentinels(true);
    }
  }, [pendingMuteTargetsUpdate, setShouldRefetchSentinels]);

  useEffect(() => {
    if (!shouldRefetchSentinels) return;
    dispatch(clearSentinelsStore());
    dispatch(getSentinels());
    setShouldRefetchSentinels(false);
  }, [sentinels, dispatch, shouldRefetchSentinels, setShouldRefetchSentinels]);

  useEffect(() => {
    if (!isInitialized) {
      dispatch(getReminders());
    }
  }, []);

  const actions =
    path === Routes.SENTINELS ? (
      <>
        <Button onClick={() => history.push(`${Routes.SENTINELS}/create`)}>
          New Sentinel
        </Button>
      </>
    ) : (
      <>
        <Button onClick={() => history.push(`${Routes.REMINDER}/create`)}>
          New Reminder
        </Button>
      </>
    );

  return (
    <div style={{ position: 'relative' }}>
      {alertMessage && (
        <AlertNotification type={alertType!} message={alertMessage} />
      )}

      <IndexManagementPageLayout
        tabs={
          <>
            <TabLink to={Routes.SENTINELS}>Sentinel</TabLink>
            <TabLink to={Routes.REMINDER}>Reminder</TabLink>
          </>
        }
        actions={actions}
        content={
          path === Routes.SENTINELS ? (
            <SentinelsTable
              dataIsLoading={getSentinelsIsLoading}
              sentinels={sentinels}
              columns={sentinelTableColumns}
              hasSearch
            />
          ) : (
            <RemindersTable
              dataIsLoading={isReminderLoading}
              reminders={reminders}
              columns={reminderTableColumns}
              hasSearch
            />
          )
        }
      />
    </div>
  );
}

const mapDispatchToProps = {};

export default connect(null, mapDispatchToProps)(SentinelsIndexPage);
